<div class="video-jump" (click)="clicked()">
  <span class="video-jump-text">{{ text() }}</span>
  <span class="video-jump-duration"> ({{ duration() | meetingAnalysisDuration }}) </span>
</div>
